import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import clsx from 'clsx';
import styles from './styles.module.less';

const AuthSubButton = ({
  text,
  link,
  linkText,
  className,
  linkClassName,
  isExternalLink = false,
}) => (
  <div className={clsx(className, styles.authSubBottom)}>
    <Typography className={styles.text}>
      {text}
      {isExternalLink ? (
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          className={linkClassName}
        >
          {linkText}
        </a>
      ) : (
        <Link to={link}>
          <span className={linkClassName}>{linkText}</span>
        </Link>
      )}
    </Typography>
  </div>
);

AuthSubButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  link: PropTypes.string,
  linkText: PropTypes.string,
  className: PropTypes.string,
  linkClassName: PropTypes.string,
  isExternalLink: PropTypes.bool,
};

export default AuthSubButton;
